var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCubeOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 11.5002C14 11.7535 13.86 11.9735 13.6467 12.0868L8.38 15.0468C8.27333 15.1268 8.14 15.1668 8 15.1668C7.86 15.1668 7.72667 15.1268 7.62 15.0468L2.35333 12.0868C2.14 11.9735 2 11.7535 2 11.5002V5.50016C2 5.24683 2.14 5.02683 2.35333 4.9135L7.62 1.9535C7.72667 1.8735 7.86 1.8335 8 1.8335C8.14 1.8335 8.27333 1.8735 8.38 1.9535L13.6467 4.9135C13.86 5.02683 14 5.24683 14 5.50016V11.5002ZM8 3.26683L4.02667 5.50016L8 7.7335L11.9733 5.50016L8 3.26683ZM3.33333 11.1068L7.33333 13.3602V8.88683L3.33333 6.64016V11.1068ZM12.6667 11.1068V6.64016L8.66667 8.88683V13.3602L12.6667 11.1068Z",
    fill: "#474949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubeOutline);
export default __webpack_public_path__ + "static/media/cube-outline.4bf77a4c2d37ea6bb8718b2bb06831fe.svg";
export { ForwardRef as ReactComponent };